import React, { useState } from 'react';
import './OngoingProjects.css';

const OngoingProjects = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const projects = [
    {
      id: 1,
      name: 'Maha Vanam',
      location: 'Aler, Yadadri',
      status: 'Booking Open',
      acres: '150+',
      highlights: 'Premium infrastructure, Strategic location',
      image: '🏢'
    },
    {
      id: 2,
      name: 'Agra Vanam',
      location: 'Aler, Kolanupaka',
      status: 'Under Development',
      acres: '120+',
      highlights: 'Nature-integrated design, Eco-friendly',
      image: '🌳'
    },
    {
      id: 3,
      name: 'Prakruthi Vanam',
      location: 'Aler, Kolanupaka',
      status: 'Under Development',
      acres: '100+',
      highlights: 'Sustainable living, Community focus',
      image: '🌲'
    }
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % projects.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + projects.length) % projects.length);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  return (
    <section className="ongoing-projects">
      {/* Eyebrow */}
      <div className="projects-eyebrow">
        <div className="eyebrow-line"></div>
        <span className="eyebrow-text">Current Ventures</span>
        <div className="eyebrow-line"></div>
      </div>

      <h2 className="projects-heading">Ongoing Projects</h2>
      <p className="projects-subtitle">Discover our most exciting developments happening right now</p>

      {/* Carousel Container */}
      <div className="carousel-container">
        <div className="carousel-wrapper">
          {projects.map((project, index) => (
            <div
              key={project.id}
              className={`carousel-slide ${index === currentSlide ? 'active' : ''}`}
            >
              <div className="project-card-carousel">
                <div className="project-image">{project.image}</div>
                
                <div className="project-details">
                  <h3 className="project-title">{project.name}</h3>
                  <p className="project-location">📍 {project.location}</p>
                  
                  <div className="project-meta">
                    <span className="meta-badge">{project.acres} Acres</span>
                    <span className={`status-badge ${project.status === 'Booking Open' ? 'booking' : 'development'}`}>
                      {project.status}
                    </span>
                  </div>

                  <p className="project-highlights">{project.highlights}</p>

                  <button className="explore-btn">Explore Project →</button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Navigation Arrows */}
        <button className="carousel-nav prev" onClick={prevSlide}>
          ←
        </button>
        <button className="carousel-nav next" onClick={nextSlide}>
          →
        </button>

        {/* Dots Navigation */}
        <div className="carousel-dots">
          {projects.map((_, index) => (
            <button
              key={index}
              className={`dot ${index === currentSlide ? 'active' : ''}`}
              onClick={() => goToSlide(index)}
            />
          ))}
        </div>
      </div>

      {/* Project Counter */}
      <div className="carousel-counter">
        Project {currentSlide + 1} of {projects.length}
      </div>
    </section>
  );
};

export default OngoingProjects;
